import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TOKEN_KEY = "jh_admin_token";

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const CATEGORIES = [
  "Signature Hot Coffee",
  "Cold Coffee",
  "Milkshakes",
  "Sparkling Refreshers",
  "Cookies & Nankhatai",
  "Food & Small Bites",
];
